
<div  class="val-barre-onglets val-flex-conteneur">
  @if (onglets.length > 0) 
  {
    @for (onglet of onglets; track $index) 
    {
      <val-onglet [onglet]="onglet"
                  (selection)="SelectionnerOnglet($event)"
                  (rafraichissement)="RafraichirOnglet($event)">
      </val-onglet>
    }
  }
</div>
